const { castBool } = require('utils/typecast');

const internals = {};

exports.getDirectValue = (value) => value;

exports.getEventValue = (evtOrValue) => {

    return evtOrValue?.target?.value ?? evtOrValue;
};

exports.getCheckedValue = (evtOrValue) => {

    return evtOrValue?.target?.checked ?? evtOrValue;
};

exports.getRadioBoolValue = (evtOrValue) => {

    return castBool(exports.getEventValue(evtOrValue));
};

exports.getAutocompleteValue = (evtOrValue, value) => {

    return typeof value !== 'undefined' ? value : exports.getEventValue(evtOrValue);
};

exports.resolveFieldOnChangeValue = ({
    field,
    value,
    args = []
}) => {

    if (typeof field?.onChange !== 'function') {
        return value;
    }

    const returnValue = field.onChange(value, ...args);
    return typeof returnValue === 'undefined' ? value : returnValue;
};

exports.buildFieldOnChange = ({
    field,
    fieldProps,
    getValue = exports.getEventValue
}) => {

    return (...args) => {

        const value = exports.resolveFieldOnChangeValue({
            field,
            value: getValue(...args),
            args
        });

        fieldProps.onChange(value);
        return value;
    };
};

exports.buildComponentFieldProps = ({
    field,
    fieldProps,
    fieldState,
    getValue
}) => {

    return {
        ...fieldProps,
        onChange: exports.buildFieldOnChange({
            field,
            fieldProps,
            getValue
        }),
        error: fieldState?.error,
        helperText: fieldState?.error ? fieldState.error.message : null
    };
};

exports.buildChangeFromPrimitive = ({
    primitive,
    field,
    args
}) => {

    const definition = exports.changePrimitives[primitive];

    if (!definition) {
        throw new Error(`Unknown form change primitive: ${primitive}`);
    }

    const value = definition.getValue(...args);

    return definition.buildChange({
        field,
        value,
        args
    });
};


module.exports = exports;
